import styled from "styled-components";

export const SliderStepsContainer = styled.div``;
